var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_30509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 20H10.0148C8.06393 19.999 6.15596 19.4275 4.52587 18.3558C2.89578 17.2841 1.61477 15.7589 0.840616 13.9683C0.0664622 12.1776 -0.16702 10.1996 0.168928 8.27791C0.504875 6.35621 1.39558 4.57474 2.73133 3.15292C4.06708 1.73111 5.78955 0.731046 7.68656 0.275918C9.58357 -0.17921 11.5723 -0.0695269 13.4077 0.591457C15.2432 1.25244 16.8452 2.43586 18.0165 3.99594C19.1878 5.55603 19.8772 7.42465 19.9998 9.37164V9.42414V20ZM10.0148 1.66664C7.80464 1.66664 5.68502 2.54461 4.12222 4.10741C2.55942 5.67022 1.68144 7.78983 1.68144 9.99997C1.68144 12.2101 2.55942 14.3297 4.12222 15.8925C5.68502 17.4553 7.80464 18.3333 10.0148 18.3333H18.3331V9.4508C18.1902 7.34107 17.252 5.36416 15.7081 3.91933C14.1641 2.4745 12.1293 1.6694 10.0148 1.66664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 5.83319H5.8335V7.49985H10.8335V5.83319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 9.16678H5.8335V10.8335H14.1668V9.16678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 12.5H5.8335V14.1667H14.1668V12.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_30509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.5d554f3f2adb608065516bb5b9641c52.svg";
export { ForwardRef as ReactComponent };